import React from 'react';

const Navbar = () => {
  return (
    <div className='navbar'>
      <h3>Hacker News Algolia API Search</h3>
    </div>
  );
};

export default Navbar;
